
import React, { Component } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import List from '@material-ui/core/List'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

import * as actions from '../../../actionTypes'
import Material from './Material'
import {EDUCATION_MATERIALS_NO_MATERIALS_TEXT} from '../../../constants'

class EducationalMaterialsContainer extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isCheckboxChecked: [],
      materialsReviewed: [],
    }

    props.navigator.hideBackButton()
    props.navigator.setForwardButtonLabel('Continue Session')
    props.navigator.withProgressBar(false)
  }

  configureReviewedMaterials() {
    this.setState(this.getReviewedMaterials())
  }

  getReviewedMaterials() {
    const reviewedInfo = !!this.props.informationReviewed

    const isCheckboxChecked = new Array(this.props.educationMaterials.length)
    this.props.educationMaterials.length ? isCheckboxChecked.fill(reviewedInfo) : isCheckboxChecked[0] = this.props.informationReviewed

    const materialsReviewed = [...isCheckboxChecked]

    if(reviewedInfo) {
      this.props.navigator.enableForward()
    } else {
      this.props.navigator.disableForward()
    }

    return {isCheckboxChecked, materialsReviewed}
  }

  componentDidUpdate(prevProps) {
    if(prevProps.educationMaterials !== this.props.educationMaterials) {
      this.configureReviewedMaterials()
    }
  }

  componentWillMount() {
    this.configureReviewedMaterials()
  }

  activeNavNextIfAllMaterialsReviewed = () => {
    if (!this.state.isCheckboxChecked.includes(false)) {
      this.props.navigator.enableForward()
      this.props.educationalMaterialsReviewed(true)
    } else {
      this.props.navigator.disableForward()
      this.props.educationalMaterialsReviewed(false)
    }
  }

  onCheckboxClick = index => {
    const isCheckboxChecked = this.state.isCheckboxChecked.slice()
    isCheckboxChecked[index] = !this.state.isCheckboxChecked[index]
    this.setState(
      {isCheckboxChecked}, 
      () => this.activeNavNextIfAllMaterialsReviewed()
    )
  }

  onLabelClick = index => {
    const materialsReviewed = this.state.materialsReviewed.slice()
    if(!materialsReviewed[index]) {
      materialsReviewed[index] = true
      this.setState({materialsReviewed})
    }
  }

  render() {
    const {t} = this.props
    return (
      <React.Fragment>
        <Grid
          alignContent="flex-start"
          className="counseling-session-page-container"
          container
          justify="center"
          spacing={8}
        >
          <Grid item xs={10}>
            <Typography variant="title">
              {t('Education')}
            </Typography>
          </Grid>
          <Grid item xs={10}>
            <Typography variant="subheading">
              {t('Review Educational Material')}
            </Typography>
          </Grid>
          <Grid item xs={10}>
            <List>
              {this.props.educationMaterials.map((material, index) => (
                <Material
                  checked={this.state.isCheckboxChecked[index] || false}
                  href={material.href}
                  key={index}
                  text={material.text}
                  onCheckboxClick={() => this.onCheckboxClick(index)}
                  onLabelClick={() => this.onLabelClick(index)}
                  sessionComplete={this.props.sessionComplete}
                />
              ))}
            </List>
          </Grid>
          <Grid item xs={10}>
            <List>
              {!this.props.educationMaterials.length && (
                <Material
                  checked={this.state.isCheckboxChecked[0] || false}
                  href=''
                  key=''
                  text={t(EDUCATION_MATERIALS_NO_MATERIALS_TEXT)}
                  onCheckboxClick={() => this.onCheckboxClick(0)}
                  onLabelClick={() => this.onLabelClick(0)}
                  sessionComplete={this.props.sessionComplete}
                />
              )}
            </List>
          </Grid>
        </Grid>
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => ({
  admin: state.globalSettings.admin,
  educationMaterials: state.counselingSession.counselingSessionData.educationMaterials,
  informationReviewed: state.counselingSession.counselingSessionData.informationReviewed,
})

const mapDispatchToProps = dispatch => ({
  educationalMaterialsReviewed(isReviewed) {
    const action = {type: actions.EDUCATIONAL_MATERIALS_REVIEWED, payload: {isReviewed}}
    dispatch(action)
  }
})

export default compose(
  translate(),
  connect(mapStateToProps, mapDispatchToProps),
)(EducationalMaterialsContainer)


// WEBPACK FOOTER //
// ./src/components/counseling-session/educational-materials/EducationalMaterialsContainer.js